import React from "react";
import { Container } from "shards-react";
import { useTranslation } from "react-i18next";

const Footer = () => {
    const { t, i18n } = useTranslation();
    return (
        <footer className="main-footer d-flex p-2 px-3 bg-blue border-top">
            <Container className="contained ml-auto my-auto mr-auto text-center text-white">
                <span>{t('common:footer.Title')}</span>
            </Container>
        </footer>
    );
}
export default Footer;